import {
  Plan,
  PlanPrice,
  PlanPriceResponse,
  PlanResponse,
  PlanSlugs,
} from "../@types";
import { currencyMask } from "../utils";

export class PlanMapper {
  static toDomain(response: PlanResponse): Plan {
    const prices: PlanPrice[] = response.prices.map((elem: PlanPriceResponse) =>
      PlanMapper.toPlanPrice(elem)
    );

    const icons: Record<string, any> = {
      [PlanSlugs.plus]: require("../assets/img/psiapp_plus_icon.png"),
      [PlanSlugs.basic]: require("../assets/img/psiapp_basic_icon.png"),
    };

    const icon = icons[response.slug];

    return {
      id: response.id,
      title: response.title,
      features: response.features.split("|"),
      description: response.description,
      description_heading: response.description_heading,
      prices,
      icon,
    };
  }

  static toPlanPrice = (response: PlanPriceResponse): PlanPrice => {
    const pricesConfig: Record<string, any> = {
      month: {
        title: "Plano mensal",
        description: "Para quem busca conhecer o app.",
        discount: null,
        value: `${currencyMask.format(response.price, 0)}/mês`,
      },
      semester: {
        title: "Plano semestral",
        description: "Plano mais popular.",
        discount: "32% OFF",
        value: `${currencyMask.format(response.price, 0)}/semestre`,
      },
      year: {
        title: "Plano anual",
        description: "12 meses pelo preço de 6.",
        discount: "45% OFF",
        value: `${currencyMask.format(response.price, 0)}/ano`,
      },
    };
    return {
      id: response.id,
      price_id: response.price_id,
      subscription_plan_id: response.subscription_plan_id,
      ...pricesConfig[response.frequency],
    };
  };
}
